// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfk_a"};